import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { map, withLatestFrom } from "rxjs/operators";
import { catchError } from "rxjs/operators";
import { switchMap } from "rxjs/operators";
import { AppState } from "src/app/reducers";
import { ToastService } from "src/app/services/toast.service";
import { ContenidoStatus } from "src/common/contenido";
import { ContenidoService } from "../../services/contenido.service";
import { SalutacionActionTypes, SalutacionPageCancelled, SalutacionPageLoaded, SalutacionPageRequested, SalutacionPageRight } from "./salutacion.actions";
import { salutacionNextPageNum, salutacionPageSize, salutacionStatus } from "./salutacion.selectors";

@Injectable()
export class SalutacionEffects {

	private readonly EMPTY_SALUTACIONES: [] = [];

	loadSalutacion$ = createEffect( () => {
		return this.actions$.pipe(
			ofType<SalutacionPageRequested>( SalutacionActionTypes.SalutacionPageRequested ),
			switchMap( action => {
				return this.service.findSalutacionStatus().pipe(
					map( remoteStatus => {
						return { action, remoteStatus };
					}),
					catchError( error => of( { action, remoteStatus: null } ) )
				)
			}),
			withLatestFrom( this.store.select( salutacionStatus ), this.store.select( salutacionNextPageNum ), this.store.select( salutacionPageSize ) ),
			switchMap( ([ data, localStatus, nextPageNum, pageSize ]) => {
				let resultAction: Observable<Action>;
				let remoteStatus: ContenidoStatus = data["remoteStatus"];
				let cleared: boolean = false;
				let status: ContenidoStatus = localStatus == null? remoteStatus: localStatus;

				if( remoteStatus == null ) {
					resultAction = of( new SalutacionPageCancelled( { status } ) );
					this.toastService.danger( "No se pudo obtener el estado de las salutaciones" );
				} else {
					// Hay actualizaciones nuevas?
					if( 
						( localStatus && localStatus.lastUpdate && localStatus.qty >= 0 ) &&
						( localStatus.lastUpdate.getTime() != remoteStatus.lastUpdate.getTime() || localStatus.qty != remoteStatus.qty )
					) {
						status = remoteStatus;
						cleared = true;
					}

					// Solo si hay nuevas actualizaciones o si se está cargando por primera vez
					if( cleared || !localStatus ) {
						if( remoteStatus.qty == 0 )
							resultAction = of( new SalutacionPageLoaded( { cleared, status, salutacion: this.EMPTY_SALUTACIONES }))
						else
							resultAction = this.service.findSalutacionByPage( { pageNum: nextPageNum, pageSize } )
								.pipe(
									map( salutacion => {
										return salutacion.length == 0?
											new SalutacionPageCancelled( { status } ):
											new SalutacionPageLoaded( { cleared, status, salutacion } );
									}),
									catchError( error => {
										this.toastService.danger( "No se pudieron obtener salutaciones" );
										return of( new SalutacionPageCancelled( { status } ) );
									})
								);
					} else
						resultAction = of( new SalutacionPageRight() );
				}

				return resultAction;
			})
		);
	});

	constructor( private actions$: Actions, private store: Store<AppState>, private service: ContenidoService, private toastService: ToastService ) {
	}

}